/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbGestionDroitsGridDto } from './FcbGestionDroitsGridDto';
import {
    FcbGestionDroitsGridDtoFromJSON,
    FcbGestionDroitsGridDtoFromJSONTyped,
    FcbGestionDroitsGridDtoToJSON,
} from './FcbGestionDroitsGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbGestionDroitsGridDtoPaginatedResults
 */
export interface FcbGestionDroitsGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbGestionDroitsGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbGestionDroitsGridDto>}
     * @memberof FcbGestionDroitsGridDtoPaginatedResults
     */
    results?: Array<FcbGestionDroitsGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbGestionDroitsGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbGestionDroitsGridDtoPaginatedResults interface.
 */
export function instanceOfFcbGestionDroitsGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbGestionDroitsGridDtoPaginatedResultsFromJSON(json: any): FcbGestionDroitsGridDtoPaginatedResults {
    return FcbGestionDroitsGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbGestionDroitsGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbGestionDroitsGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbGestionDroitsGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbGestionDroitsGridDtoPaginatedResultsToJSON(value?: FcbGestionDroitsGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbGestionDroitsGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

